export const heroText = {
  en: {
    title: {
      line1: "Find Your Fit.",
      line2: "Grow with Confidence",
    },
    description: `I guide you toward a career path shaped 
by who you are: your values, your personality, 
and your cultural roots.`,
    intro: "Hello, I’m Tiffany Bui — Guiding You Toward Your Best-Fit Career",
  },

  vi: {
    title: {
      line1: "Tìm Đúng Con Đường.",
      line2: "Vững Bước Tương Lai",
    },
    description: `Tôi đồng hành cùng bạn tìm ra con đường nghề nghiệp 
phù hợp với chính bạn — dựa trên giá trị sống, 
tính cách và bản sắc văn hoá.`,
    intro:
      "Xin chào, tôi là Tiffany Bùi — Người đồng hành định hướng sự nghiệp",
  },
};
